module.exports = __webpack_public_path__ + "img/google-play-logo.98856c7a.svg";